// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Hleb Serafimovich <hleb.serafimovich@celadon.ae>

import api from '../../../services/api';

const getArrangeCollectionStatus = async (data) => {
  return api(`/Sellitback.svc/CollectOrderFromHome?CustomerId=${data
    .customerId}&Token=${data.token}&OrderId=${data.orderId}`,
  {},
  'GET');
};

const getBookCollectionStatus = async (data) => {
  return api('/Sellitback.svc/BookCollection', data, 'POST');
};

const validatePhoneNumberService = async (data) => {
  return api('https://api.craftyclicks.co.uk/phone/1.1/validate', data, 'POST');
};


export {
  getArrangeCollectionStatus,
  getBookCollectionStatus,
  validatePhoneNumberService
};
